<template>
    <div v-loading="loading"
         :element-loading-text="$t('LnkSimpleTable.hintLoading')"
         element-loading-background="rgba(0, 0, 0, 0)"
         element-loading-spinner="el-icon-loading"
         class="lnk-simple-table">
        <div  v-if="title" class="table-title">
            <el-row>
                <div class="vbar"></div>
                <span>{{title}}</span>
            </el-row>
        </div>
        <el-row class="el-link-toolbar" v-if="showToolbar"> <!--标准列表工具栏class -->

			<lnk-table-selectfilter v-if="searchable"
									@search="onSearch"
									:options="searchOptions"
									:default-field="defaultSearchField"/>

            <slot name="search"></slot>

            <div class="toolbar-button">
                <slot name="prepend-tool-btn"></slot>
                <link-button type="primary" size="mini"
                           v-if="buttonDelete && top.deleteFlag==='Y'"
                           @click="onBeforeDelete">{{$t('LnkSimpleTable.btnDelete')}}</link-button>
                <slot name="append-tool-btn"></slot>
                <!-- 更多菜单 -->
                <el-dropdown class="toolbar-button-more" v-if="dropdownMenu"
                             @command="handleMoreButton">
                    <el-button type="primary" size="mini">
                        {{$t('LnkSimpleTable.menuMore')}}<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <slot name="dropdown-item"></slot>
                        <el-dropdown-item command="exportData" v-if="buttonExport && top.exportFlag==='Y'">{{$t('LnkSimpleTable.menuExport')}}</el-dropdown-item>
                        <el-dropdown-item command="importData" v-if="buttonImport && top.importFlag==='Y'">{{$t('LnkSimpleTable.menuExport')}}</el-dropdown-item>
                        <el-dropdown-item command="combineFilter">{{$t('LnkSimpleTable.menuMultiSearch')}}</el-dropdown-item>
                        <el-dropdown-item command="rowhistory" v-if="buttonHistory">{{$t('LnkSimpleTable.menuHistory')}}</el-dropdown-item>
                        <el-dropdown-item command="showDataDetail">{{$t('LnkSimpleTable.menuRecordDetail')}}</el-dropdown-item>
                        <el-dropdown-item command="countData">{{$t('LnkSimpleTable.menuRecordTotal')}}</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

        </el-row>
        <div class="el-table-box">
            <keep-alive>
                <el-table class="el-datagrid"
						  border
                          :height="autoHeight ? undefined : tableHeight"
                          ref="mainTable"
						  :cell-style="cellStyle"
						  :header-cell-style="headerCellStyle"
                          :data="tableDataList"
                          :row-key="tableDataList.id"
                          :default-sort="defaultSort"
                          highlight-current-row
                          @sort-change="sortChange"
                          @row-dblclick="handleDbClickRow"
                          @selection-change="handleSelectionChange"
                          @current-change="handleSingleSelectChange">
                    <el-table-column
                        v-if="rownumbers"
                        fixed
                        type="index"
                        :index="startRow"
                        width="50">
                    </el-table-column>

                    <el-table-column
                        v-if="multiSelect"
                        fixed
                        type="selection"
                        width="55" :selectable="selectable">
                    </el-table-column>
                    <slot name="prepend" :main="mainRow"></slot>
                    <el-table-column v-for="item in showFields"
                                     :prop="item.field"
                                     :label="item.name" :key="item.id"
                                     :width="item.width"
                                     :min-width="item.minWidth"
                                     :align="item.align"
                                     :sortable="item.sortable === false ? false : 'custom'"
                                     :show-overflow-tooltip="item.showOverflowTooltip"

									 :lov="item.lov"
									 :lnk-type="item.lnkType"
									 :no-search="item.noSearch"
									 :no-export="item.noExport"
									 :default-search="item.defaultSearch">
                        <template slot-scope="scope">
                            <!--<span v-if="item.lov">{{window.linkLov.getLovShowName(item.lov,scope.row[item.field])}}</span>-->
							<link-lov-text v-if="item.lov" :type="item.lov" :val="scope.row[item.field]"></link-lov-text>
                            <el-checkbox v-else-if="item.lnkType === 'checkbox'"
                                         v-model="scope.row[item.field]"
                                         true-label="Y" disabled
                                         false-label="N"></el-checkbox>
                            <el-button v-else-if="item.lnkType === 'oplink'"
                                       class="el-datagrid-hyperlink"
                                       type="text"
                                       size="mini"
                                       @click="item.opFunc && item.opFunc(scope.row)">
                                <span v-if="item.formatter">{{item.formatter(scope.row[item.field], scope.row)}}</span>
                                <span v-else>{{item.opName || scope.row[item.field]}}</span></el-button>
                            <span v-else-if="item.lnkType === 'currency'">{{scope.row[item.field] | cny}}</span>
                            <span v-else-if="item.lnkType === 'tel'">{{scope.row[item.field] | xtel}}</span>
                            <span v-else-if="item.lnkType === 'percent'">{{scope.row[item.field] | formatPercent}}%</span>
                            <span v-else-if="item.lnkType === 'date'">{{scope.row[item.field] | formatDate(item.dateFormat)}}</span>
                            <span v-else-if="item.lnkType === 'progress'">
                            <el-progress :stroke-width="16" :percentage="parseFloat(parseFloat(scope.row[item.field]).toFixed(2))"></el-progress>
                        </span>
                            <span v-else-if="item.formatter">{{item.formatter(scope.row[item.field], scope.row)}}</span>
                            <span v-else>{{scope.row[item.field]}}</span>
                        </template>
                    </el-table-column>
                    <!--<slot></slot>-->
                    <slot name="append" :main="mainRow"></slot>

					<div slot="empty">
						<link-icon icon="link-icon-zanwushuju" class="table-empty-icon"></link-icon>
						<div class="table-empty-text">暂无数据...</div>
					</div>
                </el-table>
            </keep-alive>
        </div>
        <lnk-pagination-v ref="pagination" class="lnk-pagination" v-if="pageShow && (tableDataList.length || total > (currentPage * queryParams.rows))"
                          :data="tableDataList"
                          @request-total="toggleForceTotalflag"
                          @empty-page="handleCurrentChange"
                          :page="currentPage"
                          :rows="parseInt(queryParams.rows)"
                          :total="total"
						  :show-page-num="showPageNum"
                          :page-sizes="pagerSizes"
                          :total-flag="isTotalForceFetched || queryParams.totalFlag"
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange">'
        </lnk-pagination-v>
        <slot name="pagination"></slot>

        <!-- 导出配置组件 -->
        <lnk-export-pick :data="exportFields"
                         :export-dialog.sync="exportDialog"
                         @submit-success="exportData">

        </lnk-export-pick>

        <!-- 组合查询组件-->
        <combinefiler @change="onCombineFilter"
					  :options="searchOptions"
					  :show.sync="showCombFilter"
					  :interface-path="url" ></combinefiler>
    </div>
</template>

<script>/* eslint-disable indent,no-trailing-spaces,spaced-comment,newline-per-chained-call */

import LnkExportPick from '../lnk-export-pick';
import LnkPaginationV from '../lnk-pagination-v';
import Combinefiler from '../lnk-combinefilter';
import SelectUnit from '../lnk-table-selectfilter';
import {typeOf} from '@utils/linktools';
import heightControl from '@mixins/height-control';
import LinkLovText from "../../link-components/lov/link-lov-text";

export default {
    name: 'lnk-simple-table',
    mixins: [heightControl],
    components: {
      LinkLovText,
        LnkExportPick,
        LnkPaginationV,
        Combinefiler,
        SelectUnit
    },
    data () {
        return {
            dataList: [], // 查询后端获取的列表数据结果
            total: 0, // 记录总数
            startRow: 1,
            loading: false,
            queryParams: { // 初始查询对象
                page: 1,
                rows: this.pageSizes?this.pageSizes[0]:10,
                pageFlag: this.pageFlag !== false, // 默认为true
                totalFlag: this.totalFlag === true, // 默认为false
                order: this.sortOrder,
                sort: this.sortName
            },
            searchFilter: [], //下拉筛选条件
            innerPageSizes: this.pageSizes, //可选页码，绑定一次
            currentSearchField: {}, // 当前查询选择的字段对象
            currentRow: {}, // 单选模式下当前选中的行
            currentPage: 1, //当前页码
            currentRowIndex: -1, // 当前选中行索引
            currentPageUnselectedRows: [], // 多选模式下，取消选中行
            currentPageSelectedRows: [], // 多选模式下当前页选中的行
            currentSelectedRows: {}, // 多选模式下选中行的id集合，
            dateRange: [], // 查询时间范围
            // searchFields: [], // 需要放在查询框查询的列

            cacheKeyPrefix: 'lnk-simple-table#'+location.pathname+'#', // 缓存查询条件key的前缀
            cacheObject: null,

            exportFields: null, // 导出组件
            exportDialog: false,

            mainRow: {}, // 主要记录

            combineFilter: [], //组合查询的条件
            showCombFilter: false,
            forceTotalflag: false, //强制查询总数
            isTotalForceFetched: false, //是否已强制获取总数，分页栏总数闪动的问题
            onlyFetchTotalFlag: false, //切换总数时只查询总数
            fitRows: null, //最佳适应条数
			searchOptions: []
        };
    },
    props: {
      	// 单独指定使用的http实例，不指定则按默认规则
		httpInstance: Object,
        fields: Array, // 通过props配置的显示列，也可通过插槽配置,
        title: String, // 列表标题
        multiSelect: {
            // 是否多选
            type: Boolean,
            default: false
        },
        multiSelectCache: { // 多选时，翻页返回后是否选中已选数据，不建议与returnOriginalData同时为true
            type: Boolean,
            default: false
        },
        url: {
            // 查询数据url
            type: String,
            required: false
        },
        oauth: String, // 表格标准查询安全性
        defaultNoQuery: Boolean, // 默认加载后自动查询
        pageSizes: {
            // 可选分页
            type: Array,
            default(){
                return [10, 20, 30, 50];
            }
        },
        pageFlag: {
            // 是否分页
            type: Boolean,
            default(){
                return true;
            }
        },
        sortName: {
            type: String,
            default: 'id'
        },
        sortOrder: {
            type: String,
            default: 'desc'
        },
        totalFlag: Boolean, // 是否统计总数
        params: Object, // 默认查询参数

        searchable: {
            type: Boolean,
            default(){
                return true;
            } // 是否使用标准查询栏，若要自定义查询栏可把该属性设置为false，然后使用search插槽
        },
        pageShow: {
            type: Boolean,
            default(){
                return true;
            } // 默认展示分页
        },
        buttonDelete: Boolean, // 是否显示删除按钮
        deleteUrl: String, // 删除数据URL
        beforeDelete: Function, // 删除数据前调用的函数，该函数返回false则不执行删除操作
        buttonHistory: Boolean, //修改历史按钮
        tableCode: String, //用于查询修改历史的表名
        buttonExport: Boolean, // 是否显示标准导出按钮
        buttonImport: Boolean, // 是否显示标准导入按钮
        exportUrl: String, // 导出数据url, 不指定则根据查询url拼接出来
        importUrl: String, // 导入数据url, 不指定则根据查询url计算出来
        rownumbers: {
            type: Boolean,
            default(){
                return true;
            } // 是否显示行号
        },
        dropdownMenu: Boolean, // 是否显示标准下拉菜单按钮
        selectable: Function, // 多选时判断一行数据能否被选中，false不能选中
		showPageNum: {type: Boolean,default: true}, // 是否显示分页栏的数字按钮
        height: [Number, String], // elementUI table高度
        autoHeight: Boolean, // false--组件计算并设置高度，true--不设置高度，高度随行数自增
        showToolbar: {
            type: Boolean,
            default(){
                return true;
            } // 是否显示列表工具栏
        },
        cacheQuery: Boolean, // 是否缓存上次查询条件
        cacheKey: String, // 查询条件缓存到sessionStorage的key
        selectedData: [Object, Array], // mainTable绑定数据
        returnOriginalData: Boolean, // @change事件是否返回列表的原始数据
        propMain: String, // 主要字段
        parentId: String, //头行关联 - 头Id
        parentField: String, //投行关联 - 行关联字段

        data: Array, // 传入的数组
        queryRows: { // 查询记录函数
            type: Function,
            default(params){
                if(this.url){
                    return this.$$http.post(this.url, params, true);
                }else{
                    return {success: true, rows: []};
                }
            }
        },
        queryTotal: { // 查询总数函数
            type: Function,
            default(params){
                if(this.url){
                    return this.$$http.post(this.url, params, true);
                }else{
                    return {success: true, rows: [{total: 0}]};
                }
            }
        },
        exportingData: { // 导出数据，发送请求步骤，可重写实现个性化需求
            type: Function,
            default: async function(exportUrl, params){
                try{
                    const exportResult = await this.$$http.post(exportUrl, params, true);
                    if(exportResult.success){
                        window.open(exportResult.url);
                    }else{
                        this.$nav.error('导出数据发生错误: '+exportResult.result);
                    }
                }catch(e){
                    this.$nav.error('导出数据发生错误');

                }
            }
        },
		/*列表行的高度*/
        rowHeight: {type: [String, Number], default: 40},
		/*列表头的高度*/
		headerHeight: {type: [String, Number], default: 40},
    },
    model: {
        prop: 'selectedData', // prop说:我要在该组件被使用(被父组件调用)时,v-model的值绑定给storeObj
        event: 'change'// event说:我emit(触发)change的时候，参数的值就是父组件v-model收到的值。
    },
    watch: {
        params: {
            deep: true, // 深度watch
            handler: function(){
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.setPageFirstAndQueryData();
                }, 300);
            }
        },
        parentId: {
            immediate: true,
            handler: function (val) {
                if(!this.parentField) return;
                this.setPageFirstAndQueryData();
            }
        }
    },
    computed: {
      	$$http() {
      	  return this.httpInstance || this.$http;
		},
    	/*默认显示行数*/
        defaultRows(){
            const pageSizes = this.innerPageSizes || this.pageSizes || [];
            return pageSizes[0];
        },
		/*分页条数的可选项*/
        pagerSizes(){
            var pageSizes = this.innerPageSizes || this.pageSizes || [];
			if(this.fitHeight && this.fitRows!==null && this.fitRows>this.defaultRows){
                pageSizes = linkTools.deepCopy(pageSizes);
                pageSizes.sort((a, b) => a-b);
                if(this.fitRows!==null && pageSizes.indexOf(this.fitRows)<0){
                    for(var i=pageSizes.length-1; i>=0; i--){
                        if(this.fitRows>pageSizes[i]){
                            pageSizes.splice(i+1, 0, this.fitRows);
                            break;
                        }
                    }
                }
            }
            return pageSizes;
        },
		/*默认高度*/
        defaultHeight(){
            const scrollBarHeight = this.horizonScroll?this.scrollBarHeight:0;
            const headerHeight = this.tableHeaderHeight || this.headerHeight;
            var result = this.rowHeight * 10 + headerHeight + scrollBarHeight;
            if(Array.isArray(this.pageSizes) && this.pageSizes.length){
                const size = this.pageSizes[0];
                if(typeOf(size) === 'number'){
                    result = size * this.rowHeight + headerHeight + scrollBarHeight;
                }
            }
            return result;
        },
		/*列表的高度*/
        tableHeight(){
            var result = this.defaultHeight;
            if(this.fitHeight){
                result = this.tableFitHeight;
            }else{
                if(this.height){
                    var height = this.height;
                    if(height<150){
                        height = 150;
                    }
                    result = height;
                }
            }
            return result;
        },

		/*默认的搜索字段*/
		defaultSearchField(){
			const defaultField = this.searchOptions.find((t)=>t.defaultSearch);
			if(defaultField){
				return defaultField.field;
			}
			return '';
		},

        /** 计算属性，计算filters, 返回的是默认条件及当前条件的并集 */
        filters: function () {

            var filters = [];
            if (this.params && this.params.filtersRaw) {
                filters = linkTools.deepCopy(this.params.filtersRaw);
            }
            if(Array.isArray(this.searchFilter)){
                filters = filters.concat(this.searchFilter);
            }
            return filters;
        },

        /**
         * 计算默认排序
         * @returns {{prop, order: string}}
         */
        defaultSort: function(){
            return {
                prop: this.queryParams.sort,
                order: this.queryParams.order + 'ending'
            };
        },

        /**
         * @description 显示列改用计算属性，可设置某些列为隐藏，但可做查询、导出等操作
         * @return  非隐藏列
         * @author yrf
         * @date 2018/10/25
         */
        showFields: function(){
            const showFields = [];
            const fields = this.fields || [];
            for(let i=0; i<fields.length; i++){
                const field = fields[i];
                if(field.hide !== true){
                    showFields.push(field);
                }
            }
            return showFields;
        },

        /**
         * 列表加载的数据对象
         * @return 返回列表加载的数据对象
         * @author yrf
         * @date 2018/12/26
         */
        tableDataList(){
            if(!this.url){
                return this.data; // 外部指定数据
            }else{
                return this.dataList; // url查询数据，或者通过自定义queryRows加载数据
            }
        }
    },

    methods: {
		/**
		 * @method：cellStyle
		 * @createdBy：黄健
		 * @date：2020-02-11
		 * @params：
		 * @description：列表行样式的获取方法
		 */
		cellStyle(){
			return {
				lineHeight: `${this.rowHeight}px`,
				height: `${this.rowHeight}px`
			}
		},
		/**
		 * @method：headerCellStyle
		 * @createdBy：黄健
		 * @date：2020-02-11
		 * @params：
		 * @description：列表头样式的获取方法
		 */
		headerCellStyle(){
			return {
				lineHeight: `${this.headerHeight}px`,
				height: `${this.headerHeight}px`
			}
		},

    	/**
    	 * @method：onSearch
    	 * @createdBy：黄健
    	 * @date：2020-02-11
    	 * @params：
    	 * @description：搜索事件
    	 */
		onSearch(filters){
			this.searchFilter = filters;
			this.setPageFirstAndQueryData();
		},

		/**
		 * @method：onCombineFilter
		 * @createdBy：黄健
		 * @date：2020-02-11
		 * @params：
		 * @description：组合查询事件
		 */
		onCombineFilter(filters){
			this.combineFilter = val;
			this.queryParams.page = 1;
			this.queryData();
		},

        /**
         * @method：toggleForceTotalflag
         * @createdBy:HuangJian
         * @date:2018/12/17
         * @params：
         * @description：切换强制查询总数的标志
         */
        toggleForceTotalflag(){
            if(this.queryParams.totalFlag){
                return;
            }
          this.forceTotalflag = !this.forceTotalflag;
            if(this.forceTotalflag){
                this.onlyFetchTotalFlag = true;
                this.queryData();
            }else{
                this.total = null;
                this.isTotalForceFetched = false;
            }

        },
        /**
         * @method：getFitRows
         * @createdBy:HuangJian
         * @date:2019/1/21
         * @params：
         * @description：获取最佳填充条目数
         */
        getFitRows() {
            var rslt = null;
            if (this.fitHeight && this.tableAvailHeight > 0) {
                rslt = Math.floor(this.tableAvailHeight / this.rowHeight);
            }
            this.fitRows = rslt;
            return rslt;
        },
        /**
         * 每页条数目变化
         * @param val
         */
        handleSizeChange: function (val) {
            this.queryParams.rows = val;
            this.queryData();
        },

        /**
         * 页码发生变化
         * @param val
         */
        handleCurrentChange: function (val) {
            this.queryParams.page = val;
            this.queryData();
        },

        /**
         * 双击行事件
         * @param row
         */
        handleDbClickRow: function (row) {
            // 双击时切换选中状态
            if (this.multiSelect) {
                this.$refs.mainTable.toggleRowSelection(row);
            } else {
                this.comfirmSelect();
                this.$emit('row-dblclick', row);// 单选时双击表示选中并确定--picklist监听此事件进行弹框关闭
            }
        },

        /**
         * 排序字段发生变化时回调函数
         * @param obj {prop, sort, order}
         * */
        sortChange: function (obj) {
            if (obj.prop) {
                // 从缓存中恢复查询条件导致触发此函数，防止多次请求，设置此判断
                if(this.queryParams.sort === obj.prop && this.queryParams.order === (obj.order || '').replace('ending', ''))
                    return;
                this.queryParams.sort = obj.prop;
                this.queryParams.order = obj.order.replace('ending', '');
            } else {
                this.queryParams.sort = 'id';
                this.queryParams.order = 'desc';
            }
            // this.setPageFirstAndQueryData();
            this.queryData();
        },
        /**
         * 多选时选中的行发生变化回调函数
         * */
        handleSelectionChange: function (rows) {
            if(this.loading === false){ // 加载过程中element table频繁调用此函数，且参数不明，所以加载过程中不执行内部代码
                this.currentPageUnselectedRows = [];
                for(let i=0; i< this.currentPageSelectedRows.length; i++){
                    const row = this.currentPageSelectedRows[i];
                    if(rows.indexOf(row) === -1){ // 当前选中中没有该数据
                        this.currentPageUnselectedRows.push(row); // 上次选中的数据本次已取消选中
                        // console.log('取消选中');
                    }
                }
                this.currentPageSelectedRows = rows;
                this.comfirmSelect();
            }
        },

        /**
         * 单选时选中行发生变化时的回调
         * @param row
         */
        handleSingleSelectChange: function (row) {
            this.currentRow = row;
            this.currentRowIndex = this.dataList.indexOf(row);
            // console.log('handleSingleSelectChange',this.currentRowIndex);
            if(this.cacheQuery && row){
                this.cacheTableStatus(); // 缓存列表状态，待下次进入时能回到原来的查询结果
            }
            this.comfirmSelect();
        },

        /**
         * 加载数据后设置选中效果
         * @param row
         */
        async setCurrentRow(row) {
            /*如果table没有挂载完，等待挂载完再操作*/
            while (!this.$refs.mainTable) {
                await this.$lv.$utils.delay(100)
            }

            this.$refs.mainTable.setCurrentRow(row);
            // 多选情况下，加载数据后，从缓存中查找并对先前选中数据恢复选中效果
            if(this.multiSelect && this.multiSelectCache){
                this.$nextTick(function(){
                for(const key in this.currentSelectedRows){
                    var row = this.currentSelectedRows[key];
                    this.dataList.forEach((tableRow) => {
                        if(row.id === tableRow.id){
                            this.$refs.mainTable.toggleRowSelection(tableRow);
                            }
                        });
                    }
                });
            }
        },

        /**
         * 页码归1，并查询数据
         */
        setPageFirstAndQueryData: function () {
            this.queryParams.page = 1;
            this.combineFilter = [];
            this.clearSelectedCache(); // 重新查询则清除缓存的选中数据
            this.queryData();
        },

        /**
         * 到后端接口查询数据
         */
        queryData: async function (fromCache) {
            var params = this.generateParams(fromCache);// 获取当前查询条件

            const parentId = this.getParentId(params);

            /* 头行关联 - 头id为空时跳过查询并清空数据*/
            if(this.parentField && !parentId){
                this.dataList = [];
                this.mainRow = {};
                this.total = 0;
                this.$emit('update-list', this.dataList);
                return;
            }
            this.loading = true;
            //this.dataList = [];

            const handler = (rowsData, totalData) => {
                var totalNum = -1;
                /*数据请求成功*/
                if (rowsData.success) {
                    this.onBeforeLoad(rowsData.rows);// 加载数据前执行函数
                    this.dataList = rowsData.rows;
                    totalNum = rowsData.total;
                    /*
                    * 获取主要记录
                    * */
                    this.mainRow = {};
                    if(this.propMain && Array.isArray(this.dataList)){
                        this.dataList.forEach((obj) => {
                            if(obj[this.propMain]==='Y'){
                                this.mainRow = obj;
                            }
                        });
                    }
                    if (!params.pageFlag) {
                        // 不分页查询，显示第一页 注释这三行逻辑 mvg表格分页栏数据根据默认分页栏数据显示就可以
						// let pageSizeArr = this.innerPageSizes.concat(this.dataList.length ? [this.dataList.length] : []);
                        // this.innerPageSizes = pageSizeArr.sort((a, b) => {return a - b});
						// if(this.dataList.length) this.queryParams.rows = this.dataList.length;
                        this.total = this.dataList.length;
                        this.queryParams.totalFlag = true;
                        // this.queryParams.page = 1;
                    }
                    this.onLoadSuccess();// 数据加载成功后回调
                    this.currentPage = this.queryParams.page;
                } else {
                    this.$nav.error('获取数据错误: ' + rowsData.result);
                }
                /* 总数获取成功*/
                if(totalData && totalData.success){
                    if(Array.isArray(totalData.rows) && totalData.rows[0]){
                        totalNum = totalData.rows[0].total;
                    }
                }
                if(totalNum!==-1){
                    this.total = totalNum;
                    this.isTotalForceFetched = this.forceTotalflag;
                }
                this.loading = false;
            };

            /**
             * 数据查询失败
             * @param error 错误对象
             */
            const errHander = (error) => {
                console.log(error);
                this.loading = false;
                this.$nav.error('请求失败');

            };
            /**
             * @method：onlyCountHandler
             * @createdBy:HuangJian
             * @date:2018/12/19
             * @params：
             * @description：查询总数的handler
             */
            const onlyCountHandler = (totalData) => {
                var totalNum = -1;
                /* 总数获取成功*/
                if(totalData && totalData.success){
                    if(Array.isArray(totalData.rows) && totalData.rows[0]){
                        totalNum = totalData.rows[0].total;
                    }
                }
                if(totalNum!==-1){
                    this.total = totalNum;
                    this.isTotalForceFetched = this.forceTotalflag;
                }
                this.loading = false;
            };


            if(this.forceTotalflag || params.totalFlag){
                params.totalFlag = false;

                // 统计总数参数
                const data = linkTools.deepCopy(params);
                data.onlyCountFlag = true;
                if(this.onlyFetchTotalFlag){
                    this.onlyFetchTotalFlag = false;
                    try{
                        const totalRslt = await this.queryTotal(data);
                        onlyCountHandler(totalRslt);
                    }catch (e) {
                        errHander(e);
                    }
                }else{
                    const reqs = [this.queryRows(params), this.queryTotal(data)];
                    // reqs[0] = this.queryRows(params); // 查询记录
                    // reqs[1] = this.queryTotal(data);
                    try{
                        const results = await Promise.all(reqs);
                        handler(...results);
                    }catch(e){
                        errHander(e);
                    }
                }

            }else{
                try{
                    const result = await this.queryRows(params);
                    handler(result);
                }catch(e){
                    errHander(e);
                }
                // getRows().then(handler).catch(errHander);
            }
        },
        /**
         * 数据已查询出来，在赋值到vue object前执行一些操作
         * @author 姚润发
         * @date 2019/02/27
         * @param rows 当前要加载的数据
         */
        onBeforeLoad(rows){
            this.currentPageSelectedRows = []; // 翻页加载数据前清空当前选中行数据
            this.currentPageUnselectedRows = [];
        },
        /**
         * 从后台加载数据成功后
         */
        onLoadSuccess: function(){
            if (this.multiSelect === false && this.dataList.length > 0) {
                // 选中第一行
                var selectIndex = 0;
                if(this.cacheQuery && this.cacheCurrentRowId){
                    for(var i=this.dataList.length-1; i>=0; i--){
                        if(this.cacheCurrentRowId == this.dataList[i].id){
                            selectIndex = i;
                            break;
                        }
                    }
                }

                this.$nextTick(function () {
                    // 选中指定行，需要等dom更新完毕才选中
                    this.setCurrentRow(this.dataList[selectIndex]);
                });
            }else{
                this.setCurrentRow({});
            }

            /* 更新后会设置选中，在选中行后再触发保存到缓存，此处不必调用
                if(this.cacheQuery){
                    this.cacheTableStatus(); //缓存列表状态，待下次进入时能回到原来的查询结果
                }*/
            this.startRow = (this.queryParams.page-1) * this.queryParams.rows + 1; // 设置每页开始行索引
            this.$emit('update-list', this.dataList);// 让父元素可操作返回的数据
        },

        /**
         * 记录计数
         */
        async countData() {
            var params = this.generateParams();// 获取当前查询条件
            params.onlyCountFlag = true; // 只统计总数
            try{
                const totalData = await this.queryTotal(params);
                if (totalData.success) {
                    // this.dataList = resp.data.rows;
                    this.total = totalData.rows[0].total;
                    this.$alert('当前记录总数: ' + this.total, '当前记录总数', {});
                } else {
                    this.$nav.error('获取数据错误: ' + totalData.result);
                }
            }catch(e){
                this.$nav.error('请求数据失败');

            }
        },

        /**
         * 生成查询参数对象
         */
        generateParams: function (fromCache) {
            // 合并其他条件

            var params = linkTools.deepCopy(this.queryParams);
            for (var key in this.params) {
                if (key !== 'filtersRaw') {
                    params[key] = this.params[key];
                }
            }
            // 设置filtersRaw
            if (this.filters && this.filters.length) {
                params.filtersRaw = JSON.stringify(this.filters);
            }

            /* 设置组合查询的条件*/

            if(Array.isArray(this.combineFilter)
                && this.combineFilter.length){

                if(typeOf(params.filtersRaw) === 'string'){
                    try{
                        var tmp =JSON.parse(params.filtersRaw);
                        params.filtersRaw = JSON.stringify(
                            this.combineFilter.concat(tmp)
                        );
                    }catch (e){
                        params.filtersRaw = JSON.stringify(this.combineFilter);
                    }
                }else{
                    params.filtersRaw = JSON.stringify(this.combineFilter);
                }
            }

            /* 头行关联*/

            if(this.parentField && this.parentId){
                var obj = [{id: this.parentField+'_11', property: this.parentField, value: this.parentId}];

                if(typeOf(params.filtersRaw) === 'string'){
                    try{
                        var tmp =JSON.parse(params.filtersRaw);
                        params.filtersRaw = JSON.stringify(
                            obj.concat(tmp)
                        );
                    }catch (e){
                        params.filtersRaw = JSON.stringify(obj);
                    }
                }else{
                    params.filtersRaw = JSON.stringify(obj);
                }
            }

            // 设置安全性
            /* if (this.oauthFlag) {
                    params.oauthFlag = true;
                    params.oauth = window.CURRENT_ORIGIN_TOP.oauth;
                }*/
            params.oauth = this.oauth || params.oauth || window.CURRENT_ORIGIN_TOP.oauth;
            return params;

        },

        /**
         * 缓存当前列表状态
         */
        cacheTableStatus: function(){
            var cacheObj={};
            cacheObj.queryParams = this.queryParams;
            cacheObj.total = this.total;
            cacheObj.dateRange = this.dateRange;// 日期范围
            cacheObj.currentSearchField = this.currentSearchField;// 当前查询列表
            cacheObj.currentRowId = this.currentRow.id;// 当前选中记录的id，用于恢复选中行
            // cacheObj.lastParams = this.generateParams(); //当前的查询参数,暂时不必缓存，查询时重新生成即可
            // cacheObj.params = this.params; //当前父对象的查询参数，因为父页面使用组件过程中可能发生改变，并非初始值,同上，暂不缓存
            cacheObj.oauth = this.oauth ? this.oauth : window.CURRENT_ORIGIN_TOP.oauth;// 缓存当前安全性，恢复时进行比较，若安全性不同则弹框提示，其余条件不变

            // console.log('cache currentRowId',cacheObj.currentRowId);

            window.sessionStorage.setItem(this.cacheKeyPrefix+this.cacheKey, JSON.stringify(cacheObj));
            // cacheObj.dataList = this.dataList;//当前列表数据，--不缓存,1、占用空间大，2、安全问题
        },

        /**
         * 读取缓存中的值，恢复列表上次查询状态
         */
        reinstatedFormCache: function(){
            var lastTableStatusJson = window.sessionStorage.getItem(this.cacheKeyPrefix+this.cacheKey);
            // console.log(lastTableStatusJson);
            if(lastTableStatusJson){
                var lastTableStatusObj = JSON.parse(lastTableStatusJson);

                this.total = lastTableStatusObj.total;
                this.queryParams = lastTableStatusObj.queryParams;
                this.dateRange = lastTableStatusObj.dateRange;
                this.currentSearchField = lastTableStatusObj.currentSearchField;// 查询列

                this.cacheCurrentRowId = lastTableStatusObj.currentRowId;

                if((this.oauth ? this.oauth : window.CURRENT_ORIGIN_TOP.oauth) !== lastTableStatusObj.oauth){
                    this.$message.warning('安全性条件自上次缓存后发生变化，可能导致结果与预期不一致');
                }
                // console.log(this.queryParams);
                // 恢复选中的行。。。。
            }
        },

        /**
         * 多选情况下，清除其他页的选中数据的缓存
         * @author 姚润发
         * @date 2018/12/19
         * @params：
         * */
        clearSelectedCache(){
            this.currentSelectedRows = {};
        },
        /**
         * 确定选择，向上触发事件，返回数据
         */
        comfirmSelect: function () {
            if (this.multiSelect) {
                // 多选情况下，需要缓存翻页前选中的数据时
                if(this.multiSelectCache){
                    let currentPageRowsCopy = linkTools.deepCopy(this.currentPageSelectedRows);
                    // 把选中行加入缓存
                    for(let i=0; i<currentPageRowsCopy.length; i++){
                        if(currentPageRowsCopy[i].id == undefined){
                            this.$nav.error('multiSelectCache属性设置为true时加载行数据必须包含唯一性id字段');
                            return;
                        }
                        const rowId = currentPageRowsCopy[i].id;
                        this.$set(this.currentSelectedRows, rowId, currentPageRowsCopy[i]);
                    }
                    // 从缓存中移除取消选中的行
                    for(let i=0; i< this.currentPageUnselectedRows.length; i++){
                        const unSelectedRowId = this.currentPageUnselectedRows[i].id;
                        if(this.currentSelectedRows[unSelectedRowId] !== undefined){
                            this.$delete(this.currentSelectedRows, unSelectedRowId);
                        }
                    }
                    currentPageRowsCopy = null;
                    var selectList = [];
                    for(const key in this.currentSelectedRows){
                        selectList.push(this.currentSelectedRows[key]);
                    }
                    this.$emit('change', selectList);
                }else{
                    if(this.returnOriginalData === true){
                        this.$emit('change', this.currentPageSelectedRows);
                    }else{
                        this.$emit('change', linkTools.deepCopy(this.currentPageSelectedRows));
                    }
                }

            } else {
                if(this.returnOriginalData === true) {
                    this.$emit('change', this.currentRow);
                }else{
                    this.$emit('change', linkTools.deepCopy(this.currentRow));
                }
            }
        },

        /**
         * 下拉菜单回调函数
         * @param command 点击对应菜单项的command命令
         */
        handleMoreButton: function (command) {
            switch (command) {
                case 'showDataDetail':
                    // 记录明细
                    if (this.currentRow.id) {
                        this.showDataDetail(this.currentRow);
                    } else {
                        this.$nav.error('请选择需要查看明细的一行数据');
                    }
                    break;

                case 'countData':
                    this.countData();
                    break;

                case 'exportData':
                    if(!this.exportFields){
                        const fields = this.getFields();
                        const exportFields = [];
                        for(let i=0; i<fields.length; i++){
                            const item = fields[i];
                            exportFields.push(item);
                        }
                        this.exportFields = exportFields;
                    }
                    this.exportDialog = true;
                    break;
                case 'importData':
                    this.handleImport();
                    break;
                case 'combineFilter':
                    this.showCombFilter = true;
                    break;
                case 'rowhistory':
                    /* 行修改历史 */
                    if (this.currentRow.id) {
                        if(!this.tableCode){
                            this.$nav.error('请设置相关联的表名 table-code！');
                        }else{
                            this.showRecordHistory(this.currentRow.id, this.tableCode);
                        }
                    } else {
                        this.$nav.error('请选择需要查看明细的一行数据');
                    }
                    break;
                default:
                    this.$emit('dropdown-click', command);
                    break; // 其他非标准命令由外层自己编写处理逻辑
            }
        },

        /**
         * 删除前调用函数，返回false或者Promise且被reject则执行删除
         */
        onBeforeDelete: function(){
            if(this.multiSelect){
                if(this.currentPageSelectedRows.length === 0){
                    this.$message.warning('请选择需要删除的数据');
                    return;
                }
                const before = this.beforeDelete(this.currentPageSelectedRows);
                if(before && before.then){
                    before.then(
                        () => {
                            this.deleteRow();
                        });// 注意箭头函数作用域
                }else if(before !== false){
                    this.deleteRow();
                }
            }else{
                if(!this.currentRow.id){
                    this.$message.warning('请选择需要删除的数据');
                    return;
                }

                const before = this.beforeDelete(this.currentRow, this.currentRowIndex);
                if(before && before.then){
                    before.then(
                        () => {
                            this.deleteRow();
                        });// 注意箭头函数作用域
                }else if(before !== false){
                    this.deleteRow();
                }
            }
        },

        /**
         * 标准删除函数，删除当前选中的一行
         */
        async deleteRow() {
            // alert('我要删除数据:'+this.currentRowIndex);
            if (this.multiSelect && this.currentPageSelectedRows.length > 0) {
                // 删除多行
                try{
                    const deleteData = await this.$$http.post(this.deleteUrl, this.currentPageSelectedRows);
                    if (deleteData.success) {
                        if (this.currentPageSelectedRows.length === this.dataList.length) {
                            this.queryData(); // 当前页全部删除，重新查询
                            return;
                        }
                        // 当前页部分删除，一条条在页面删除
                        for (let i = 0; i < this.currentPageSelectedRows.length; i++) {
                            var index = this.dataList.indexOf(this.currentPageSelectedRows[i]);
                            this.dataList.splice(index, 1);
                        }
                    } else {
                        this.$nav.error('删除出现错误:' + deleteData.result);
                    }
                }catch(e){
                    this.$nav.error('删除数据出现错误，请查询确认数据是否已删除或联系系统管理员');

                }
                // this.$emit('change',linkTools.deepCopy(this.currentPageSelectedRows));
            } else {
                // 单行删除
                var index = this.currentRowIndex;
                try{
                    const deleteData = await this.$$http.post(this.deleteUrl, this.currentRow, true);
                    if (deleteData.success) {
                        this.dataList.splice(index, 1);
                        if (this.dataList.length === 0) {
                            this.queryData();
                            return;
                        }
                        if (index >= this.dataList.length) {
                            this.setCurrentRow(this.dataList[index - 1]);
                        } else {
                            this.setCurrentRow(this.dataList[index]);
                        }
                    } else {
                        this.$nav.error('删除出现错误:' + deleteData.result);
                    }
                }catch(e){
                    this.$nav.error('删除数据出现错误，请查询确认数据是否已删除或联系系统管理员');

                }
            }


        },

        /**
         * 生成左上角查询可选列数组
         */
        /*genSearchFields: function () {

            var fields = this.getFields();
            var searchFields = [];
            for(let i=0; i<fields.length; i++){
                const field = fields[i];
                if(!field.noSearch){
                    searchFields.push(field);
                    if(field.defaultSearch && !this.currentSearchField.field){
                        this.currentSearchField = field;
                        this.queryParams.searchParam = this.currentSearchField.field;
                    }
                }
            }
            if(!this.currentSearchField.field&& searchFields.length>0){
                this.currentSearchField = searchFields[0];
                this.queryParams.searchParam = this.currentSearchField.field;
            }
            if(this.currentSearchField.lov){
                this.queryParams.searchCondition = 'eq';
            }
            this.searchFields = searchFields;
        },*/

        /**
         * 获取列表的有prop名称的html定义列及所有js定义的列
         * @returns {Array}
         */
        getFields(){
            let allFields = [];
            const elTableColumns = this.$getChildComponent('el-table-column', false);
            elTableColumns.forEach((column) => {
                const config = {
                    field: column.prop || column.property,
                    name: column.label,
                    lov: column.$attrs.lov, // 值列表列
                    lnkType: column.$attrs['lnk-type'], // 其他类型，如日期date,数值num
                    noSearch: column.$attrs['no-search'] !== undefined, // 该列不参与查询
                    noExport: column.$attrs['no-export'] !== undefined, // 该列不导出
                    defaultSearch: column.$attrs['default-search'] !== undefined, // 默认查询改了吧
					customOperator: column.$attrs['custom-operator'] //  自定义查询条件 不设置则根据配置生成查询条件
                };
                if(config.field){
                    allFields.push(config);
                }
            });
            const rawFields = this.fields || [];
            allFields = allFields.map((config) => {
                const rawField = rawFields.find((obj) => obj.field === config.field);
                return rawField || config;
            });

            rawFields.forEach((jsField) => {
                if(jsField.hide){
                    allFields.push(jsField);
                }
            })
            /*var lastIndex = 0;
            rawFields.map((jsField, index) => {
                const htmField = allFields.find((config) => config.field === jsField.field);
                if(!htmField){
                    // allFields中找不到，即为隐藏列
                }
                return jsField;
            })*/
			return allFields;
        },
        /**
         * @method：getParentId
         * @createdBy:HuangJian
         * @date:2018/12/10
         * @params：
         * @description：获取头id
         */
        getParentId(params){

            if(!this.parentField){
                return null;
            }

            if(this.parentId){
                return this.parentId;
            }
            if(!params){
                params = this.generateParams();
            }

            const test = params[this.parentField];

            if(test && typeOf(test) === 'string' ){
                return test;
            }

            if(params.filtersRaw){
                var filtersRaw = [];
                try {
                    filtersRaw = JSON.parse(params.filtersRaw);
                    for(var i in filtersRaw){
                        var filter = filtersRaw[i];
                        if(filter && filter.property && filter.property === this.parentField){
                            return filter.value;
                        }
                    }
                }catch (e) {}
            }
            return null;
        },


        /**
         * @method：handleImport
         * @createdBy:HuangJian
         * @date:2018/11/30
         * @params：
         * @description：从文件中导入数据
         */
        handleImport(){
            const parentId = this.getParentId();
            if(this.parentField && !parentId){
                this.$nav.error('没有关联主(头)记录，不能导入！');
                return;
            }

            var inputTag = document.createElement('input');
            inputTag.type = 'file';
            inputTag.accept = '.csv';

            const getLovMap = async (lov) => {
                var result ={};
                const lovList = await this.$lov.getLovByType(lov)
                (lovList || []).forEach((obj) => {
                    result[obj.name] = obj.val;
                });
                return result;
            };

            const uploadHandler = async (data) => {
                var fdata = new FormData();

                const fields = this.getFields() || [];

                var importsRaw = [];

                var order = 0;
                for (const field of fields) {
                    var newRaw = {
                        field: field.field,
                        title: field.name,
                        order: order++
                    };

                    if(field.lov){
                        newRaw.lov = field.lov;
                        newRaw.lovMap = await getLovMap(field.lov);
                    }
                    if(this.parentField && parentId){
                        newRaw.parentid = parentId;
                        newRaw.parentField = this.parentField;
                    }

                    importsRaw.push(newRaw);
                }

              importsRaw = JSON.stringify(importsRaw);


                fdata.append('importsRaw', importsRaw);
                fdata.append('importFile', data);
                fdata.append('importsDefValRaw', JSON.stringify({}));

                const url = this.importUrl || (this.url || '').replace(/\/([a-zA-Z0-9])*$/, '/importData');

                this.$$http.post(url, fdata, false, {
                    url: url,
                    method: 'post',
                    data: fdata,
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then((data) => {
                    if(data.success){
                        this.setPageFirstAndQueryData();
                        this.$nav.success('导入成功！');
                    }else{
                        this.$nav.error(data.result || data.message || '未知错误！');
                    }
                }).catch((err) => {
                    this.$nav.error(err);
                });
            };

            inputTag.onchange = () => {
                const file = inputTag.files && inputTag.files[0];
                const reader = new FileReader();
                const fileData = reader.readAsBinaryString(file);
                uploadHandler(file);
            };
            inputTag.click();
        },

        /**
         * 导出数据到csv
         */
        async exportData(exportObj){
            // this.exportData(exportFields);
            const fields = exportObj.fields;
            const exportsRaw = [];
            for(let i=0; i<fields.length; i++){
                // 构建导出参数exportsRaw
                const field = fields[i];
                if(field.noExport){
                    continue;
                }
                var exportsCol = {
                    title: field.name,
                    field: field.field,
                    order: i
                };
                if(field.lov){
                    var lovArray = await this.$lov.getLovByType(field.lov);
                    var lovMap = {};
                    for(let j=0; j<lovArray.length; j++){
                        lovMap[lovArray[j].val] = lovArray[j].name;
                    }
                    exportsCol.lov = field.lov;
                    exportsCol.lovMap = lovMap;
                }
                exportsRaw.push(exportsCol);
            }
            // 导出数据
            var params = this.generateParams();
            params.exportsRaw = JSON.stringify(exportsRaw);
            if(exportObj.range){
                params.exportCurrentPage = exportObj.range === 'all'?'N':'Y';
            }

            if(exportObj.fileName){
                params.exportFileName = exportObj.fileName;
            }

            if(exportObj.fileType){
                params.exportFileType = exportObj.fileType;
            }

            var exportUrl = this.exportUrl ? this.exportUrl : this.url+'/exportData';
            this.loading = true;
            await this.exportingData(exportUrl, params);
            this.loading = false;

        }
    },
    created(){

        if(this.fitHeight){
            const firstQuery = () => {
                this.queryParams.rows = this.defaultRows;
                if(this.fitRows!==null && this.fitRows>this.defaultRows){
                    this.queryParams.rows = this.fitRows;
                }
                if(this.cacheQuery){
                    this.reinstatedFormCache();// 默认排序设置需要在挂载之前设置
                    this.queryData(true);
                }else if (!this.defaultNoQuery) {
                    this.setPageFirstAndQueryData(true);
                }
            };
            // const isFitRows = (rows) => this.pageSizes.indexOf(rows)<0;
            /* 监听表格调节事件 */
            this.$on('resized', () => {
                if(!this.isHeightFited){
                    this.isHeightFited = true;
                    this.getFitRows();
                    firstQuery();
                }

            });
        }
    },

    beforeMount() {
        if(!this.fitHeight){
            if(this.cacheQuery){
                this.reinstatedFormCache();// 默认排序设置需要在挂载之前设置
                this.queryData(true);
            }else if (!this.defaultNoQuery) {
                this.setPageFirstAndQueryData(true);
            }
        }
    },
    mounted(){
    	this.searchOptions = this.getFields();
    },

    beforeDestroy: function(){
        if(this.cacheQuery){
            this.cacheTableStatus(); // 销毁前缓存列表状态，待下次进入时能回到原来的查询结果，直接跳转页面不进入到此页
        }
    }
};
</script>

<style lang="scss">
	.lnk-simple-table{
		.table-title {
			line-height: 14px;
			height: 14px;
			margin-bottom: 16px;
			margin-left: 2px;
			position: relative;
			letter-spacing: 1px;
			.vbar {
				display: inline-block;
				width: 3px;
				height: 14px;
				background: #1f74ff;
				vertical-align: -2px;
				margin-right: -4px;
			}
			span {
				font-size: 14px;
				font-weight: 600;
				padding-left: 8px;
				display: inline-block;
				color: #22252a;
			}
		}
		.el-link-toolbar{
			.lnk-table-selectfilter{
				display: inline-flex;
			}
			.toolbar-button{
				float: right;
				.link-button+.link-button,
				.link-button+.el-button,
				.el-button+.el-button,
				.el-button+.link-button{
					margin-left: 8px;
				}
				.el-dropdown{
					margin-left: 8px;
				}
			}
		}
		.el-link-toolbar + .el-table-box{
			margin-top: 16px;
		}
		.table-empty-icon{
			font-size: 80px;
		}
		.table-empty-text{
			font-size: 14px;
			line-height: 1;
			color: rgba(0,0,0,0.65);
		}
		.lnk-pagination{
			margin-top: 16px;
		}
	}
</style>
